import React from 'react';
import dayjs from 'dayjs';
import { ReactComponent as Child } from '../assets/svg/icons/Child.svg';
import { getSchoolCurriculum, prepareYearOfStudying } from '../helpers/StudentHelper';
import '../assets/styles/custom/components/children_info.scss';

const ChildrenInfo = (props) => {
    const { childrenInfo, isProfile } = props;
    const childrenArrLength = childrenInfo.length;
    const childrenInfoFields = childrenInfo.map((item) => {
        return (
            <div
                key={item.id}
                className={`profile-info-child-info-container ${
                    childrenArrLength === 4 ? 'four-items' : childrenArrLength === 3 ? 'three-items' : ''
                }`}
            >
                <div className="profile-info-child-age-container">
                    <Child className="child-icon" />
                    <span className="profile-info-child-age">{dayjs().diff(item.age, 'years')} years old</span>
                </div>
                <span className="profile-info-child-year-of-study">
                    {getSchoolCurriculum(item.studying_year)} {childrenArrLength == 3 && !isProfile ? <br /> : null}({' '}
                    {prepareYearOfStudying(item.studying_year)} )
                </span>
            </div>
        );
    });
    return (
        <div className={isProfile ? 'profile-info-child-container' : 'info-child-container'}>{childrenInfoFields}</div>
    );
};

export default ChildrenInfo;
